{
  "success": {
    "analyses/setMovable": "Análisis actualizado",
    "analyses/moveIntoPlan": "Análisis movido al plan exitosamente",
    "analyses/remove": "Análisis desplanificado exitosamente",
    "analysisDefinitions/create": "Nueva definición de análisis añadida",
    "analysisDefinitions/edit": "Definición de análisis editada",
    "analysisDefinitions/remove": "Definición de análisis eliminada",
    "analysisDraft/create": "Nuevo borrador de análisis añadido",
    "analysisDraft/edit": "Borrador de análisis editado",
    "samples/delete-unlocked": "Todas las muestras no planificadas eliminadas",
    "assets/remove": "Instrumento eliminado exitosamente",
    "assets/create": "Nuevo instrumento añadido",
    "assets/edit": "Instrumento editado",
    "competenceGroups/create": "Nuevo grupo de competencia creado exitosamente",
    "competenceGroups/edit": "Grupo de competencia editado exitosamente",
    "competenceGroups/remove": "Grupo de competencia eliminado exitosamente",
    "iap/run": "IAP ejecutado exitosamente",
    "iap/runFillInSamples": "Muestras rellenadas exitosamente",
    "integrationSheets/createActionSheet": "Hoja añadida",
    "integrationSheets/createProjectTemplateSheets": "Hoja añadida",
    "integrationSheets/createSampleSheet": "Hoja añadida",
    "integrationSheets/editActionSheet": "Hoja editada",
    "integrationSheets/editProjectTemplateSheet": "Hoja editada",
    "integrationSheets/editSampleSheet": "Hoja editada",
    "integrationSheets/removeActionSheet": "Hoja eliminada",
    "integrationSheets/removeProjectTemplateSheet": "Hoja eliminada",
    "integrationSheets/removeSampleSheet": "Hoja eliminada",
    "integrationSheets/saveSapConversionSheet": "Hoja de Importación de Proyecto guardada",
    "members/create": "Miembro añadido",
    "members/createAsAdmin": "Miembro añadido",
    "members/edit": "Miembro editado",
    "members/archive": "Miembro archivado",
    "projectActions/editPlanned": "Acción de proyecto editada",
    "projectActions/move": "Acción de proyecto añadida al horario",
    "projectActions/setMovable": "Acción de proyecto actualizada",
    "projectActions/setLocation": "Ubicación actualizada",
    "projectActions/setLocationUnplanned": "Ubicación actualizada",
    "projectActions/editUnplanned": "Acción de proyecto no planificada editada",
    "projectActions/removePlanned": "Proyecto desplanificado",
    "projects/create": "Nuevo proyecto añadido",
    "projects/edit": "Proyecto actualizado",
    "projects/remove": "Proyecto eliminado",
    "projects/delete-unplanned": "Todos los proyectos no planificados eliminados",
    "projects/lockProject": "Proyecto bloqueado",
    "projects/unlockProject": "Proyecto desbloqueado",
    "projectTemplates/create": "Nueva plantilla de proyecto creada",
    "projectTemplates/createDraft": "Nuevo borrador de plantilla de proyecto creado",
    "projectTemplates/edit": "Plantilla de proyecto editada",
    "projectTemplates/editDraft": "Borrador de plantilla de proyecto editado",
    "projectTemplates/remove": "Plantilla de proyecto eliminada",
    "whiteTasks/remove": "Tarea eliminada exitosamente",
    "whiteTasks/create": "Nueva tarea añadida",
    "whiteTasks/edit": "Tarea editada exitosamente",
    "whiteTasks/createRecurrence": "Recurrencia creada",
    "whiteTasks/removeRecurrence": "Tareas recurrentes eliminadas",
    "teamStatus/start": "Modo Simulación activado",
    "teamStatus/accept": "Cambios del Modo Simulación aplicados",
    "teamStatus/discard": "Cambios del Modo Simulación descartados",
    "customers/addCustomer": "Cliente añadido",
    "customers/editCustomer": "Cliente editado",
    "customers/deleteCustomer": "Cliente eliminado",
    "team/create-api-token": "Token API creado",
    "team/delete-api-token": "Token API eliminado"
  },
  "error": {
    "analyses/remove/ERROR": "Error al desplanificar el análisis",
    "analysisDefinitions/create/ERROR": "Error al añadir nueva definición de análisis",
    "analysisDefinitions/remove/ERROR": "Error al eliminar la definición de análisis",
    "assets/remove/ERROR": "Error al eliminar el instrumento",
    "assets/create/ERROR": "Error al añadir el instrumento",
    "auth/login/ERROR": "Error al iniciar sesión",
    "competenceGroups/create/ERROR": "Error al crear el grupo de competencia",
    "competenceGroups/remove/ERROR": "Error al eliminar el grupo de competencia",
    "iap/run/ERROR": "Error al ejecutar el IAP",
    "iap/runFillInSamples/ERROR": "Error al rellenar muestras",
    "integrationSheets/createActionSheet/ERROR": "Error al añadir la hoja",
    "integrationSheets/createProjectTemplateSheets/ERROR": "Error al añadir la hoja",
    "integrationSheets/createSampleSheet/ERROR": "Error al añadir la hoja",
    "integrationSheets/editActionSheet/ERROR": "Error al editar la hoja",
    "integrationSheets/editProjectTemplateSheet/ERROR": "Error al editar la hoja",
    "integrationSheets/editSampleSheet/ERROR": "Error al editar la hoja",
    "integrationSheets/removeActionSheet/ERROR": "Ocurrió un error al intentar eliminar la hoja",
    "integrationSheets/removeProjectTemplateSheet/ERROR": "Ocurrió un error al intentar eliminar la hoja",
    "integrationSheets/removeSampleSheet/ERROR": "Ocurrió un error al intentar eliminar la hoja",
    "loading/fetchAll/ERROR": "Error al cargar",
    "members/create/ERROR": "Error al añadir el miembro",
    "members/createAsAdmin/ERROR": "Error al añadir el miembro",
    "members/archive/ERROR": "Error al archivar el miembro",
    "projectActions/move/ERROR": "Error al mover la acción al horario",
    "projectActions/removePlanned/ERROR": "Error al desplanificar la acción",
    "projectActions/setLocation/ERROR": "Error al actualizar la ubicación",
    "projectActions/setLocationUnplanned/ERROR": "Error al actualizar la ubicación",
    "projects/create/ERROR": "Error al añadir nuevo proyecto",
    "projects/remove/ERROR": "Error al eliminar el proyecto",
    "projects/delete-unplanned/ERROR": "Error al eliminar proyectos no planificados",
    "projects/lockProject/ERROR": "Error al bloquear las acciones",
    "projectTemplates/create/ERROR": "Error al crear nueva plantilla de proyecto",
    "projectTemplates/createDraft/ERROR": "Error al crear nuevo borrador de plantilla de proyecto",
    "projectTemplates/remove/ERROR": "Error al eliminar la plantilla de proyecto",
    "whiteTasks/remove/ERROR": "Error al eliminar la tarea",
    "whiteTasks/create/ERROR": "Error al crear",
    "teamStatus/start/ERROR": "Error al activar el Modo Simulación",
    "teamStatus/accept/ERROR": "Error al aplicar los cambios del Modo Simulación",
    "teamStatus/discard/ERROR": "Error al descartar los cambios del Modo Simulación",
    "customers/deleteCustomer/ERROR": "No se pudo eliminar el cliente",
    "customers/addCustomer/ERROR": "No se pudo añadir el cliente",
    "customers/editCustomer/ERROR": "No se pudo editar el cliente",
    "team/create-api-token/ERROR": "No se pudo crear el token API",
    "team/delete-api-token/ERROR": "No se pudo eliminar el token API"
  },
  "adhoc": {
    "welcomeBack": "¡Bienvenido de nuevo!",
    "noSoundDetected": "No se detectó sonido. Por favor inténtelo de nuevo.",
    "noMicrophoneDetected": "No se detectó micrófono. Por favor inténtelo de nuevo.",
    "iapRunning": "Un momento — el IAP para su equipo está en ejecución",
    "failedDiscardNotLoggedOut": "Error al descartar cambios. ¡No se cerró la sesión!",
    "cannotDragRecurrentTask": "No puede arrastrar y soltar una tarea gris recurrente",
    "cannotMoveImportedTasks": "No puede mover tareas importadas",
    "noCheckboxesSelected": "No hay casillas seleccionadas",
    "analysisUpdatedRefresh": "Análisis actualizado, por favor actualice la página",
    "analysisUpdatedByAnotherUser": "El análisis ha sido actualizado por otro usuario, por favor actualice la página",
    "copiedToClipboard": "Copiado al portapapeles",
    "couldNotCopyToClipboard": "No se pudo copiar al portapapeles",
    "chooseFirstAction": "Por favor elija el primer {{itemType}}",
    "chooseSecondAction": "Por favor elija el segundo {{itemType}}",
    "chooseTwoDifferent": "Por favor elija dos {{itemType}} diferentes",
    "constraintConflicts": "Esa restricción entra en conflicto con las existentes",
    "sampleCreated": "Muestra creada",
    "sampleDeleted": "Muestra eliminada",
    "samplesUpdated": "Muestras actualizadas",
    "sampleMarkedDone": "Muestra marcada como hecha",
    "memberPermissionsChanged": "Permisos del miembro cambiados",
    "chooseUniqueName": "Por favor elija un nombre único",
    "fillRequiredFields": "Por favor complete los campos requeridos",
    "couldNotDetermineSampleIdDone": "No se pudo determinar el ID de la muestra para marcar como hecha",
    "couldNotDetermineSampleIdDelete": "No se pudo determinar el ID de la muestra para eliminar",
    "couldNotDetermineSampleIdDeleteMissing": "No se pudo determinar el ID de la muestra para eliminar — datos faltantes. Verifique la consola para más detalles.",
    "anErrorOccurred": "Ocurrió un Error",
    "selectFileBeforeSubmitting": "Por favor seleccione al menos un archivo antes de enviar",
    "helpPageUpdated": "Página de ayuda actualizada",
    "processingStarted": "Procesamiento iniciado",
    "failedLoadingIcalFiles": "Error al cargar archivos iCalendar",
    "unsortBeforePasting": "Por favor deshaga la ordenación de la tabla antes de pegar múltiples celdas.",
    "fillAllRequiredFields": "Por favor complete todos los campos requeridos",
    "unsavedChangesConfirmLeave": "Tiene cambios sin guardar. Para confirmar que desea salir, presione el botón atrás nuevamente.",
    "provideSheetName": "Por favor proporcione un Nombre de Hoja",
    "sheetNameAlreadyExists": "Ya existe una hoja con ese nombre",
    "provideSheetType": "Por favor proporcione un Tipo de Hoja",
    "didNotSpellDeleteProperly": "No escribió ELIMINAR correctamente",
    "domainMustStartWithAt": "El dominio debe comenzar con '@'",
    "fillOutRequiredFields": "Por favor complete los campos requeridos",
    "selectValidDates": "Por favor seleccione fechas válidas",
    "noIapModeSelected": "No se seleccionó ningún modo IAP. Por favor seleccione un modo.",
    "oneCollaboratorForWorkday": "Solo se puede seleccionar un colaborador cuando se marca el día laboral completo",
    "fillRequiredDateTimeFields": "Por favor complete todos los campos de fecha y hora requeridos",
    "endMustBeAfterStart": "El final de la tarea debe ser después del inicio",
    "recurrencesCannotExceed365": "El número de recurrencias no puede ser mayor que 365",
    "pleaseFillNumberAndInterval": "Por favor complete el número e intervalo de recurrencias",
    "pleaseFillNumberOfRecurrences": "Por favor complete el número de recurrencias",
    "pleaseFillIntervalOfRecurrences": "Por favor complete el intervalo de recurrencias",
    "pleaseFillAllPeriodFields": "Por favor complete todos los campos del período",
    "pleaseSelectReportType": "Por favor seleccione al menos un tipo de informe",
    "reportEmptyInInterval": "El {{fileName}} está vacío en el intervalo dado",
    "noSoundDetected": "No se detectó sonido. Por favor inténtelo de nuevo.",
    "noMicrophoneDetected": "No se detectó micrófono. Por favor inténtelo de nuevo.",
    "promptTooLong": "Prompt demasiado largo (máximo 1200 caracteres)",
    "nameTooLong": "Nombre demasiado largo (máximo 100 caracteres)"
  }
}
